module.exports = __webpack_public_path__ + "img/icon_tip@3x.a12da03c.png";